import { styled } from "@mui/material/styles";
const AutocompleteMain = styled("div")(({ theme }) => ({
  marginBottom: "15px",
  position: "relative",
  "& input.error": {
    border: `1px solid ${theme.palette.error.main} `,
    color: theme.palette.error.main,
  },
  "& input": {
    width: "100%",
    height: "48px",
    background: "#F2F2F2",
    borderRadius: "10px",
    border: `1px solid transparent`,
    fontFamily: theme.typography.fontFamily,
    padding: "10px",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    "&:focus": {
      outline: "none",
      borderColor: theme.palette.primary.main,
    },
    "::placeholder": {
      color: "rgba(11, 11, 11, 0.6)",
    },
  },
  "& span.error": {
    fontFamily: theme.typography.fontFamily,
    color: "red",
    fontWeight: 400,
    fontSize: "14px",
    position: "absolute",
    top: "100%",
    left: 0,
  },

  "& .pac-container": {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    fontFamily: theme.typography.fontFamily,
    color: "#F2F2F2",
    zIndex: 1000,
    fontSize: "1px",
  },

  "& .pac-logo": { padding: "5px", cursor: "pointer" },
  "& .pac-item:hover": { backgroundColor: "#f5f5f5" },
}));

const GoogleMapMainDiv = styled("div")(({ theme }) => ({
  // height: "100vh",
  width: "100%",
  "& .gm-style .gm-style-iw-c": {
    padding: "7px !important",
    maxWidth: "220px !important",
    maxHeight: "300px !important",
    // minWidth: "0px !important",
    position: "absolute",
    boxSizing: "border-box",
    overflow: "hidden",
    top: "0",
    left: "0",
    transform: "translate(-50%,-100%)",
    backgroundColor: "#F6F6F4",
    borderRadius: "5px",
    width: "60px",
    border: "1.93px solid #0C0C0C",
    boxShadow: "0 2px 7px 1px rgba(0,0,0,0.3)",
  },
  "& .gm-style-iw-d": { overflow: "hidden !important" },
  "& .distance_main": {
    p: {
      fontSize: "11px",
      fontWeight: 600,
      lineHeight: "15px",
      letterSpacing: "0em",
      textAlign: "center",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& button.gm-ui-hover-effect": {
    display: "none !important",
  },
  "& .gm-style-iw-tc": {
    display: "none !important",
  },
}));

export { AutocompleteMain, GoogleMapMainDiv };
